const actionTypes = require('../loansConstants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');

const fetchLoanGeneralData = loanId => ({
    type: actionTypes.FETCH_LOAN_GENERAL_DATA,
    payload: {
        loanId
    }
});

const fetchLoanGeneralDataSuccess = (loanId, data, loanType) => ({
    type: actionTypes.FETCH_LOAN_GENERAL_DATA_SUCCESS,
    payload: {
        loanId,
        data,
        loanType
    }
});

const fetchLoanGeneralDataFailure = (loanId, error, loanType) => ({
    type: actionTypes.FETCH_LOAN_GENERAL_DATA_FAILURE,
    payload: {
        loanId,
        error,
        loanType
    }
});

const requestLoanGeneralData = loanId => (dispatch, getState) => {
    const loan = getState().loans.getIn(['byId', loanId]);
    const loanType = loan.get('type'); // TODO: This is not in the reducer, check it out.

    if (loan.getIn(['generalData', 'success'])) {
        return Promise.resolve();
    }

    const detailsRequestData = {
        query: {
            producto: loan.get('newProduct'),
            numeroContrato: loan.get('newContractNumber')
        }
    };

    dispatch(fetchLoanGeneralData(loanId));
    return APIGet({ dispatch, endpoint: 'loansAndMortgages', params: detailsRequestData })
        .then(response => dispatch(fetchLoanGeneralDataSuccess(loanId, response, loanType)))
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchLoanGeneralDataFailure(loanId, response.error, loanType));
            } else throw response;
        })
};

module.exports = { requestLoanGeneralData };
